export default function FeaturedPublications() {
  return (
    <section className="py-32 bg-gradient-to-b from-[#0A1628] to-[#0F2744]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-serif font-bold text-white mb-6">Editor's Achievements</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            에디터가 리딩하여 성과를 낸 프로젝트로 실체적 능력을 증명합니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* 성과 1 */}
          <div className="bg-[#0A1628] rounded-2xl p-10 border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all">
            <div className="flex flex-wrap items-center gap-3 mb-6">
              <span className="inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-base font-medium whitespace-nowrap">
                <i className="ri-trophy-line text-lg"></i>
                국내 종합 1위
              </span>
              <span className="inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-base font-medium whitespace-nowrap">
                <i className="ri-rocket-line text-lg"></i>
                북펀딩 8,412%
              </span>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed">
              경제경영 분야 역대 1위 북펀딩 달성
            </p>
          </div>

          {/* 성과 2 */}
          <div className="bg-[#0A1628] rounded-2xl p-10 border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all">
            <div className="flex flex-wrap items-center gap-3 mb-6">
              <span className="inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-base font-medium whitespace-nowrap">
                <i className="ri-trophy-line text-lg"></i>
                국내 종합 1위
              </span>
              <span className="inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-base font-medium whitespace-nowrap">
                <i className="ri-rocket-line text-lg"></i>
                북펀딩 7,240%
              </span>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed">
              미국 주식 투자의 확실한 기준을 세워주는 책
            </p>
          </div>

          {/* 성과 3 */}
          <div className="bg-[#0A1628] rounded-2xl p-10 border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all">
            <div className="flex flex-col gap-3 mb-6">
              <span className="inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-base font-medium whitespace-nowrap">
                <i className="ri-medal-line text-lg"></i>
                누적 10만 부
              </span>
              <span className="inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-base font-medium whitespace-nowrap">
                <i className="ri-star-line text-lg"></i>
                TOP100 7주
              </span>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed">
              교보 6위 / 예스 8위 기록, 국내도서 TOP100 7주 연속 진입한 롱셀링 도서
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
